
import convertDate from '~/js/modules/date';
import Accordion from '~/js/modules/accordion';

const onModxLoad = () => {
  convertDate();
};

window.addEventListener(`DOMContentLoaded`, () => {
  convertDate();

  const accordions = document.querySelectorAll(`.accordion`);

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list')) {
        new Accordion(accordion)
      }
    });
  }

  document.onpdopage_load = onModxLoad

  const close_btn = document.querySelectorAll('.js-close-btn')
  if (close_btn) {
    close_btn.forEach((el) => {
      el.addEventListener('click', () => {
        el.parentNode.remove()
      })
    })
  }
});
